<template>
  <div class="pix-page">
   <b-container fluid class="px-0">
  <b-row class="pix-layout mx-0 ">
      
      <b-col cols="12" md="6"  class="px-0">
        <div class="pix-card">
          <div v-if="pixResponse" class="pix-result">
            <h5 class="pix-label">Pagamento via Pix</h5>
             <h2 class="pix-amount">
              {{ Number(pixResponse.amount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
            </h2>
             <div class="qr-box">
                <img :src="`data:image/png;base64,${pixResponse.qr_code_image}`" />
             </div>
             <div class="pix-copy">
                <label>Código copia e cola</label>
                <div class="pix-copy-row">
                  <input :value="pixResponse.qr_code_data" readonly />
                  <button @click="copyPix">Copiar</button>
                </div>
             </div>
             <p class="pix-expiration">Expira em {{ formatDate(pixResponse.expiration_date) }}</p>
          </div>

        <div v-else class="pix-form">
          <h3 class="mb-2">Pagamento via Pix</h3>
          <validation-observer ref="pixRules">
            <form @submit.prevent="validateForm">
              
              <validation-provider rules="required" name="Nome do Pagador">
                <b-form-group label="Nome do Pagador" label-for="payerName">
                  <b-form-input
                    id="payerName"
                    v-model="form.payerName"
                    placeholder="Digite o nome do pagador"
                  />
                </b-form-group>
              </validation-provider>
              
            <validation-provider rules="required|cpfCnpj" name="CPF/CNPJ">
              <b-form-group label="CPF/CNPJ" label-for="payerTaxId">
                <b-form-input
                  id="payerTaxId"
                  v-model="form.payerTaxId"
                  placeholder="Digite o CPF ou CNPJ"
                />
              </b-form-group>
            </validation-provider>

              <button type="submit" class="submit-btn" :disabled="loading" >
                {{ loading ? "Gerando Pix..." : "Gerar Pix" }}
              </button>
            </form>
          </validation-observer>
        </div>
        </div>
      </b-col>

      <b-col cols="12" md="4"  class="pix-side">
        <div class="side-content-wrapper">
          <information :data="res" class="mt-2" />
        </div>
      </b-col>

    </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BContainer,
  BFormInput,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import { extend } from 'vee-validate';
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Information from '@/layouts/components/payment-link/Information.vue'
import ContactCard from '@/layouts/components/payment-link/contactCard.vue'
import { getPixQRCode } from "@/service/pay/pay";

extend('cpfCnpj', {
  validate: value => {
    const digits = value.replace(/\D/g, '');
    return digits.length === 11 || digits.length === 14;
  },
  message: 'CPF ou CNPJ inválido'
});

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormTextarea,
    BContainer,
    ValidationProvider,
    ValidationObserver,
    ContactCard,
    Information,
  },

  props: {
    hash: {
      type: String,
      required: true,
    },
    res: Object
  },
  data() {
    return {
      loading: false,
      pixResponse: null,
      form: {
        payerName: "",
        payerTaxId: "",
        expirationDate: "",
      },
    };
  },
  mounted() {
  if (
    this.res.payment?.qr_code_data &&
    this.res.payment?.qr_code_image &&
    this.isPixValid()
  ) {
    this.pixResponse = {
      qr_code_data: this.res.payment.qr_code_data,
      qr_code_image: this.res.payment.qr_code_image,
      expiration_date: this.res.payment.qr_code_expiration,
      amount: Number( this.res.payment?.value || this.res.product?.amount || 0)
    }
  }
},
  methods: {
    formatExpirationDate(date) {
      if (!date) return null;
      const d = new Date(date);
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },

    async validateForm() {
      const success = await this.$refs.pixRules.validate();
      if (!success) return;

      this.submitPix();
    },
    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      return d.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    copyPix() {
      const text = this.pixResponse?.qr_code_data;

      if (!text) return;

      navigator.clipboard.writeText(text)
        .then(() => {
          this.$bvToast.toast("Código Pix copiado com sucesso!", {
            variant: "success",
            autoHideDelay: 2000,
            solid: true,
          });
        })
        .catch(() => {
          this.$bvToast.toast("Erro ao copiar o código", {
            variant: "danger",
            autoHideDelay: 2000,
            solid: true,
          });
        });
    },
    isPixValid() {
      if (!this.res.payment?.qr_code_expiration) return false

      const now = new Date()
      const expiration = new Date(this.res.payment.qr_code_expiration)

      return now < expiration
    },
    async submitPix() {
      
      try {
        this.loading = true;
        const expiration = new Date()
        expiration.setDate(expiration.getDate() + 4)

        const payload = {
          payer_name: this.form.payerName,
          payer_tax_id: this.form.payerTaxId.replace(/\D/g, ""),
          expiration_date: this.formatExpirationDate(expiration),
        };

        const response = await getPixQRCode(this.hash, payload);
        if (!response || response.status !== 200 || !response.data) {
          throw new Error("Resposta inválida da API");
        }

        this.pixResponse = response.data;
        this.loading = false;
      } catch (err) {
        console.error("Erro ao gerar Pix:", err);

        this.$bvToast.toast("Erro ao gerar Pix", {
          variant: "danger",
          autoHideDelay: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@core/scss/base/pages/page-payment-pix.scss";
</style>
